module.exports = __webpack_public_path__ + "static/media/dialog-footer.1c43c905.svg";